import './assets/fonts.module.css'
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { Auth0Plugin, getAuth0Instance } from '@my-prtg-com/shared/src/auth0'
import vuetify from './plugins/vuetify'
import { useRequestInterceptor, useResponseInterceptor } from '@my-prtg-com/shared/src/axios'
import { ToastPlugin } from '@my-prtg-com/shared/src/toast'
import CAccount from '@my-prtg-com/shared/src/components/container/CAccount'
import { defineEndpoints as defineEndpointsForChargebee } from '@my-prtg-com/shared/src/chargebee'
import { queryClient } from '@my-prtg-com/shared/src/query'
import { VueQueryPlugin } from '@tanstack/vue-query'

if (process.env.VUE_APP_SENTRY_DSN && process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', process.env.DOMAIN_NAME, /^\//],
      }),
    ],
  })
}

defineEndpointsForChargebee({
  subscription: {
    POST: () => '/customer/subscriptions',
    PUT: (id) => `/customer/subscriptions/${id}`,
    GET: (id) => `/customer/subscriptions/${id}`,
  },
  billing: {
    POST: () => '/customer/billing_details',
  },
})

Vue.config.productionTip = false

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: appState => {
    router.push(appState?.targetUrl || window.location.pathname)
  },
  component: CAccount,
})
Vue.use(ToastPlugin)
Vue.use(VueQueryPlugin, { queryClient })

axios.defaults.baseURL = process.env.VUE_APP_API_URL
useRequestInterceptor(axios, getAuth0Instance)
useResponseInterceptor(axios)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
